import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import CryptoTable from '../../components/crypto/CryptoTable';
import { urls } from '../../services/Server';

export default class Crypto extends Component {
  /*
    This component is listing available crypto currencies.
  */

  constructor(props) {
    super(props);

    this.state = {
      cryptos: [],
      cryptosLoaded: false
    };

    this.loadCryptos();
  }

  cryptosLoaded = cryptos => {
    this.setState({
      cryptos,
      cryptosLoaded: true
    });
  };

  loadCryptos = () =>
    fetch(urls.crypto, { credentials: 'include' })
      .then(response => response.json())
      .then(json => {
        this.cryptosLoaded(json);
      });

  render() {
    return (
      <Row>
        <div className="box search-box">
          <div className="header">
            <h2> {this.props.pageName} </h2>
          </div>
          {this.state.cryptosLoaded ? (
            <CryptoTable cryptos={this.state.cryptos} />
          ) : (
            <Loader />
          )}
        </div>
      </Row>
    );
  }
}

Crypto.propTypes = {
  pageName: PropTypes.string.isRequired
};
